<template>
  <div>
    <button name="favorite_button" :class="getFavoriteClass" @click="toggleFavorite">
      <i class="icon icon-star"></i> <span>{{ $t("shop.favorite") }}</span>
    </button>
    <tippy v-if="isFavoriteEmpty" :to="'favorite_button'" theme="wf-bp" :arrow="true">
      <div>
        <p>{{ $t("shop.warnings.favorite_empty") }}</p>
      </div>
    </tippy>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ShopFavoriteLink",

  computed: {
    ...mapGetters("shop", ["getShopView", "isFavoriteEmpty"]),

    getFavoriteClass() {
      return this.getShopView === "favorite"
        ? "shop__favorite shop__favorite--active"
        : "shop__favorite";
    },
  },

  methods: {
    toggleFavorite() {
      if (!this.isFavoriteEmpty && this.getShopView === "list") {
        this.$store.commit("shop/writeShopViewType", "favorite");
      } else {
        this.$store.commit("shop/writeShopViewType", "list");
      }
    },
  },
};
</script>
